module.exports = __webpack_public_path__ + "static/media/logo_diqz.688a4156.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_diqz.png
// module id = 694
// module chunks = 0